/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
function n(n) {
  return n && "esri.renderers.visualVariables.SizeVariable" === n.declaredClass;
}

function e(n) {
  return null != n && !isNaN(n) && isFinite(n);
}

function i(n) {
  return n.valueExpression ? "expression" : n.field && "string" == typeof n.field ? "field" : "unknown";
}

function l(n, e) {
  var l = e || i(n),
      a = n.valueUnit || "unknown";
  return "unknown" === l ? "constant" : n.stops ? "stops" : null != n.minSize && null != n.maxSize && null != n.minDataValue && null != n.maxDataValue ? "clamped-linear" : "unknown" === a ? null != n.minSize && null != n.minDataValue ? n.minSize && n.minDataValue ? "proportional" : "additive" : "identity" : "real-world-size";
}

export { i as getInputValueType, l as getTransformationType, n as isSizeVariable, e as isValidNumber };